import styled from 'styled-components';
import { InverseClearButton } from '#/shared/components/Styled';
import LogoIconBase from '#/shared/components/GeneratedIcons/trimet/LogoIcon';
import CloseIconBase from '#/shared/components/GeneratedIcons/generic/Close';
import { Z_INDEX_TOP } from '#/shared/constants';

export const DismissableWarningBackground = styled.div`
  z-index: ${Z_INDEX_TOP};
  background-color: ${props => props.theme.warningBackground};
  color: ${props => props.theme.warningFontColor};
  width: 100vw;
  height: 100vh;
  position: fixed;
  top: 0;
  left: 0;
  display: flex;
  flex-direction: column;
`;

export const DismissableWarningClose = styled(InverseClearButton).attrs({
  tabIndex: -1,
})`
  display: flex;
  align-items: center;
  justify-content: center;
  align-self: flex-end;
  min-width: 64px;
  flex: 0 0 48px;
  opacity: ${props => props.theme.inactiveOpacity};
  @media (any-hover: hover) {
    &:hover {
      background-color: transparent;
      opacity: 1;
    }
  }
  &:focus,
  &:active {
    background-color: transparent;
  }
`;

export const DismissableWarningMainRow = styled.div`
  display: flex;
  justify-content: center;
  flex: 1 1 auto;
`;

export const DismissableWarningContent = styled.div`
  font-size: 1.2em;
  max-width: 400px;
  align-items: center;
  min-height: 250px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-self: center;
  padding: 8px;
`;

export const DismissableWarningMessage = styled.div`
  padding: 8px;
  text-align: center;
`;

export const DismissableWarningMessageEmphasis = styled.a.attrs(props => ({
  'aria-label': props.label,
}))`
  color: ${props => props.theme.warningFontColorEmphasis};
`;

export const DismissableWarningDismiss = styled(InverseClearButton)`
  color: ${props => props.theme.warningFontColor};
  font-size: 0.9em;
  padding: 0.25em 2em;
  border: ${props => props.theme.warningFontColor} solid 1px;
  border-radius: 8px;

  @media (any-hover: hover) {
    &:hover {
      background-color: ${props => props.theme.warningButtonHoverBackground};
    }
  }
`;

export const DismissableWarningCloseIcon = styled(CloseIconBase).attrs(
  props => ({
    width: 24,
    height: 24,
    title: 'Close Warning',
    fill: props.theme.warningFontColor,
  })
)``;

export const CloseIcon = styled(CloseIconBase)`
  border: solid red 3px;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  cursor: pointer;
`;

export const TrimetIcon = styled(LogoIconBase).attrs({
  width: 96,
  height: 96,
  role: 'presentation',
})``;
